import { createAction } from "@reduxjs/toolkit";

import type { Organization } from "@packages/client";

export const loadRefOrganizationsAction = createAction(
  "app/organizations/load_more_organizations_success_action",
  function prepare(organizations: Organization[]) {
    return {
      payload: organizations
    };
  }
);
